export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/life-services-image2-053a11bbcefece2ac8e5bad1631bb1e2.jpg";